import React from "react";
import { FormattedHTMLMessage } from "react-intl";
import { Segment } from "../lib/types/types";
import { getSafe } from "../lib/utils/getSafe";
import { useVerificationService } from "../lib/state/contextHooks";

const TryAgainButtonComponent = () => {
  const verificationService = useVerificationService();
  const currentSegment = getSafe<Segment>(() => verificationService.verificationResponse.segment);

  const tryAgainHandler = React.useCallback(() => {
    // If the program is embedded in an iframe (i.e. not directly embedded on a site),
    //  we can simply reload the page to get proper state resetting (Ticket: NEXUS-135)
    if (window.self !== window.top) {
      const url = new URL(window.location.href);
      url.searchParams.delete("verificationId");
      window.location.replace(url);
      return;
    }

    (async () => {
      const trackingId = undefined;
      const forceNewVerificationRequest = true;
      const { programId } = verificationService;
      verificationService.resetState();
      await verificationService.fetchNewVerificationRequest(
        programId,
        currentSegment,
        undefined,
        trackingId,
        forceNewVerificationRequest,
      );
    })();
  }, [verificationService.programId, currentSegment]);

  return (
    <button
      type="button"
      className="sid-btn sid-btn-light sid-btn__try-again"
      onClick={tryAgainHandler}
      onKeyPress={tryAgainHandler}
    >
      <FormattedHTMLMessage id="tryAgain" defaultMessage="Try again" />
    </button>
  );
};

export { TryAgainButtonComponent };
